import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Full-viewport boot state — shown while the initial silent auth resolves. */
export function Splash() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-dvh place-items-center bg-background" role="status" aria-live="polite">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="size-5 animate-spin text-primary" />
        <span className="text-sm">{/* Loading… */ t('common.loading')}</span>
      </div>
    </div>
  );
}
